import { FormInstance, Modal } from 'antd';
import { NavigateFunction } from 'react-router-dom';
import { accountStore } from 'store/accountStore';
import { playlistApiService } from '../services/playlistApiService';
import { PlaylistInterface } from '../types/playlistType';

export const getPlaylistAddHandlers = ({
  form,
  navigate,
}: {
  form: FormInstance;
  navigate: NavigateFunction;
}): {
  handleAddClick: () => Promise<void>;
} => {
  const handleAddClick = async (): Promise<void> => {
    try {
      const values = await form.validateFields();
      const user = accountStore.getAccount();
      const playlist: PlaylistInterface = {
        id: -1,
        title: values.title,
        mrss_url: values.mrss_url,
        description: values.description,
        active: values.active,
        playlist_items: [],
        platform_id: user?.platform.id || 1,
        created: values.created,
        modified: values.modified,
        type: values.type || 'manual',
      };

      await playlistApiService.create(playlist);
      navigate('/playlists/');
    } catch (error) {
      Modal.error({
        title: 'Error',
        content: 'Failed to add : ' + error,
        okText: 'Confirm',
      });
    }
  };

  return {
    handleAddClick,
  };
};
